import * as React from "react";
import {ElementWithType} from "src/app/model/ReviewData";
import {observer} from "mobx-react";
import {ElementType} from "src/app/constant/Enums";
import PlainTextElement from "src/app/component/review/element/PlainTextElement";
import HrefElement from "src/app/component/review/element/HrefElement";
import ImageElement from "src/app/component/review/element/ImageElement";
import RadioButtonGroup from "src/app/component/review/element/RadioButtonGroupElement";

interface FragmentElementProps {
    data: ElementWithType;
}

const FragmentElement = observer((props: FragmentElementProps) => {
    const {elementType, element} = props.data;

    if (ElementType.PLAIN_TEXT == elementType) {
        return <PlainTextElement element={element}></PlainTextElement>
    } 
    if (ElementType.HREF == elementType) {
        return <HrefElement element={element}></HrefElement>
    } 
    if (ElementType.IMAGE == elementType) {
        return <ImageElement element={element}></ImageElement>
    } 
    if (ElementType.RADIO_BUTTON_GROUP == elementType) {
        return <RadioButtonGroup element={element}></RadioButtonGroup>
    } else {
        return (
            <span>N/A</span>
        )
    }
});

export default FragmentElement;